import React from 'react';
import { LazySuspense, lazy } from 'react-loosely-lazy';
import Drawer from '@atlaskit/drawer';
import {
	useTemplateLibraryState,
	useTemplateLibraryActions,
} from '@atlassian/proforma-template-library-store';
import { useUFOComponentExperience } from '@atlassian/ufo';
import { proformaTemplateLibraryExperience } from '../common/ui/experience';
import type { ProformaTemplateLibraryProps } from './main';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyProformaTemplateLibrary = lazy(() =>
	import(/* webpackChunkName: "async-jira-proforma-template-library-main" */ './main').then(
		({ ProformaTemplateLibraryWithAnalytics }) => ProformaTemplateLibraryWithAnalytics,
	),
);

const LazyProformaTemplateLibraryWithUFO = (props: ProformaTemplateLibraryProps) => {
	useUFOComponentExperience(proformaTemplateLibraryExperience);
	return <LazyProformaTemplateLibrary {...props} />;
};

export const ProformaTemplateLibraryInDrawer = (props: ProformaTemplateLibraryProps) => {
	const { isTemplateLibraryOpen } = useTemplateLibraryState();
	const { setIsTemplateLibraryOpen } = useTemplateLibraryActions();

	return (
		<Drawer
			testId="proforma-template-library.ui.proforma-template-library-drawer"
			isOpen={isTemplateLibraryOpen}
			onClose={() => setIsTemplateLibraryOpen(false)}
			width="full"
			// eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
			overrides={{
				Content: {
					cssFn: (defaultStyles) => ({ ...defaultStyles, marginTop: 0 }),
				},
			}}
		>
			<LazySuspense fallback={null}>
				<LazyProformaTemplateLibraryWithUFO {...props} />
			</LazySuspense>
		</Drawer>
	);
};
